import * as React from 'react';
import { CheckIcon } from '@phosphor-icons/react/Check';
import { MinusIcon } from '@phosphor-icons/react/Minus';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { cn } from '../../../utils/cn';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    data-slot="checkbox"
    className={cn(
      'peer border-input size-4 shrink-0 cursor-pointer rounded-sm border shadow-sm transition-colors',
      'focus-visible:ring-ring focus-visible:ring-1 focus-visible:outline-none',
      'disabled:pointer-events-none disabled:opacity-50',
      'data-[state=checked]:bg-accent data-[state=checked]:text-accent-foreground data-[state=checked]:border-accent',
      'data-[state=indeterminate]:bg-accent data-[state=indeterminate]:text-accent-foreground data-[state=indeterminate]:border-accent',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      {props.checked === 'indeterminate' ? (
        <MinusIcon
          aria-hidden
          className="size-3"
          weight="bold"
        />
      ) : (
        <CheckIcon
          aria-hidden
          className="size-3"
          weight="bold"
        />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = 'Checkbox';

export { Checkbox };
